import { useDefinicoesDeCampo } from "../../nucleo/tickets-avancado";
import { Campo } from "../ui";

interface Props {
  campoId: string;
  valor: string;
  aoMudar: (campoId: string, valor: string) => void;
}

/** Filtro da fila por um campo personalizado e o valor dele. */
export function FiltroPorCampo({ campoId, valor, aoMudar }: Props) {
  const definicoes = useDefinicoesDeCampo();
  const ativas = (definicoes.data ?? []).filter((campo) => campo.ativo);
  if (ativas.length === 0) return null;
  const campo = ativas.find((item) => item.id === campoId);
  const opcoes =
    campo?.tipo === "sim_nao"
      ? [
          { valor: "true", rotulo: "Sim" },
          { valor: "false", rotulo: "Não" },
        ]
      : campo && (campo.tipo === "lista" || campo.tipo === "multipla")
        ? campo.opcoes.map((opcao) => ({ valor: opcao, rotulo: opcao }))
        : null;
  return (
    <>
      <div className="campo">
        <label className="campo__rotulo" htmlFor="filtro-campo">Campo personalizado</label>
        <select id="filtro-campo" className="campo__controle" value={campoId} onChange={(e) => aoMudar(e.target.value, "")}>
          <option value="">Nenhum</option>
          {ativas.map((item) => (
            <option value={item.id} key={item.id}>{item.rotulo}</option>
          ))}
        </select>
      </div>
      {campo ? (
        opcoes ? (
          <div className="campo">
            <label className="campo__rotulo" htmlFor="filtro-campo-valor">Valor</label>
            <select id="filtro-campo-valor" className="campo__controle" value={valor} onChange={(e) => aoMudar(campoId, e.target.value)}>
              <option value="">Escolha…</option>
              {opcoes.map((opcao) => (
                <option value={opcao.valor} key={opcao.valor}>{opcao.rotulo}</option>
              ))}
            </select>
          </div>
        ) : (
          <Campo rotulo="Valor" value={valor} onChange={(e) => aoMudar(campoId, e.target.value)} />
        )
      ) : null}
    </>
  );
}
